export { GOOGLE_FONT_STYLESHEETS, LOCAL_FONT_FAMILIES } from '@web-store-platforms/constants';
